import request from "_private/utils/request";

// 获取列表数据
export function FetchFindByPage(data) {
  return request({
    headers: { type: "json" },
    url: "/driverInfo/findDriverInfoPageList",
    method: "post",
    data
  });
}

//请求所属企业下拉数据
export function FetchCorpOptionList() {
  return request({
    url: "",
    method: "get"
  });
}

//请求绑定车辆下拉数据
export function FetchVehicleOptionList(data) {
  return request({
    url: "/driverInfo/getVehicleInfoTree",
    method: "post",
    data
  });
}

//保存司机信息编辑
export function saveEditDriver(data) {
  return request({
    headers: { type: "json" },
    url: "/driverInfo/saveDriverInfo",
    method: "post",
    data
  });
}

//删除司机信息
export function deleteDriver(data) {
  return request({
    headers: { type: "json" },
    url: "/driverInfo/deleteDriverInfo",
    method: "post",
    data
  });
}
